module.exports = __webpack_public_path__ + "static/media/cpg_annasconsidering_1.912f97fe.png";